import { z } from 'zod';
import i18n from '@/i18n';

export const profileEditSchema = z.object({
    public_name: z
        .string()
        // @ts-ignore
        .min(1, i18n.t('name_required'))
        // @ts-ignore
        .max(100, i18n.t('name_too_long'))
        // @ts-ignore
        .regex(/^[^\p{Emoji}\p{Emoji_Component}]+$/u, i18n.t('emoji_not_allowed'))
        // @ts-ignore
        .regex(/^[\p{L}\s]+$/u, i18n.t('only_letters_and_spaces_are_allowed'))
        .refine((val) => val.trim().length > 0, {
            // @ts-ignore
            message: i18n.t('name_can_not_consist_only_of_spaces'),
        }),
    about_me: z
        .string()
        .trim()
        // @ts-ignore
        .min(1, i18n.t('desc_required'))
        // @ts-ignore
        .max(255, i18n.t('desc_max_len', { len: 255 })),
    //region: z.object({ label: z.string(), value: z.number() }).nullable(),
    regions: z
        .array(
            z.object({
                label: z.string(),
                value: z.number(),
            }),
        )
        .nullable(),
    purpose: z.enum(['love', 'fun', 'not_specified']).nullable(),
    // @ts-ignore
    dob: z.string().min(1, { message: i18n.t('dob_required') }),
    travel_plans:
        z
            .string()
            // @ts-ignore
            .min(1, i18n.t('field_must_not_be_empty'))
            // @ts-ignore
            .max(500, i18n.t('desc_too_long'))
            .nullable(),
    // @ts-ignore
    gender: z.enum(['male', 'female'], { message: i18n.t('gender_required') }),
    catch_my_interest: z
        .string()
        .trim()
        // @ts-ignore
        .max(255, i18n.t('desc_max_len', { len: 255 })),
    my_ideal_evening: z
        .string()
        .trim()
        // @ts-ignore
        .max(255, i18n.t('desc_max_len', { len: 255 })),
    height: z
        .string()
        .refine(
            val => {
                const num = Number(val)
                if (Number.isNaN(num)) return false
                return num >= 140
            },
            { message: 'profile.min_height' }
        )
        .refine(
            val => {
                const num = Number(val)
                if (Number.isNaN(num)) return false
                return num <= 220
            },
            { message: 'profile.max_height' }
        ),
    marital_status: z.enum(['single', 'divorced', 'widowed', 'not_specified']),
    smoking: z.enum(['non_smoker', 'smoker', 'occasionally']),
    drinking: z.enum(['non_drinker', 'occasionally', 'i_drink']),
    children: z.enum(['none', 'live_with_me', 'live_separately']),
    language_proficiency: z
        .string()
        .trim()
        // @ts-ignore
        .superRefine((val, ctx) => {
            const len = 255
            if (val.length > len)
                ctx.addIssue(i18n.t('desc_max_len', { len }))
        }),
});

export type ProfileEditSchemaType = z.infer<typeof profileEditSchema>;
